<template>
  <div>
    <point-select class="ad_type" :config="{ must: true }" labelText="广告类型" v-model="elType" :pList="adTypes">
      <div slot="empty" class="my-sel-empty__data">暂未开通，请联系管理员</div>
    </point-select>
    <el-form label-width="90px" class="put_order_form">
      <el-form-item label="投放时间" size="mini">
        <SearchTime v-model="searchTime"></SearchTime>
      </el-form-item>
      <el-form-item class="must custom" label="合同编码">
        <el-input placeholder="请输入正确的合同编码" :maxlength="30" v-model="contract" @blur="contractHandle" @keyup.enter.native="contractHandle">
          <i slot="suffix" class="iconfont icon-biaodan-tianxie"></i>
        </el-input>
      </el-form-item>
      <el-button
        type="default"
        plain
        class="btn download_btn"
        icon="iconfont icon-download-template"
        @click="downloadTemplate">
        下载Excel模板
      </el-button>
      <el-upload
        class="upload_btn"
        :headers="upHeaders"
        :disabled="disable"
        :show-file-list="false"
        accept=".xlsx"
        name="file"
        :action="config.importExcel"
        :with-credentials="true"
        :before-upload="beforeUpload"
        :on-progress="uploadProgress"
        :on-success="uploadSuccess">
        <el-button type="primary" class="btn import_btn" :class="{'is-disabled':disable}" icon="iconfont icon-shangchuananniu">
          {{importStatus === 2 ? '重新上传Excel文件' : '导入Excel文件' }}
        </el-button>
      </el-upload>
      <span class="txt_sub">仅支持xlsx格式，大小不超过6MB</span>
    </el-form>
  </div>
</template>

<script>
import PointSelect from '@/views/PutOrder/components/OrderForm/Select'
import SearchTime from './MySearchTime'

export default {
  name: "ImportCondition",
  components: { PointSelect, SearchTime },
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    },
    importStatus: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      elType: [],
      fileObj: {
        name: '',
        progress: 0
      },
      searchTime: [],
      contract: '',
      searchCondition: {
        advertType: '',
        startDate: '',
        endDate: '',
        contractNo: '',
      },
      importResultData: {}
    }
  },
  computed: {
    adTypes() {
      // 实时广告 => CPR收费(2)、定制商业(3)、普通公益(4)、定制公益(5)
      const origin = this.$store.state.common.advertTypes || []
      const auth = origin.filter(e => [2, 3, 4, 5].indexOf(e.value) > -1)
      return auth.map(e => {
        e.code = e.value
        e.name = e.label
        return e
      })
    },
    upHeaders () {
      return {
        token: localStorage.getItem('user_ticket') || undefined
      }
    },
    disable() {
      let { advertType, contractNo } = this.searchCondition
      return !advertType || !(contractNo || '').trim()
    }
  },
  watch: {
    searchTime (o) {
      if (!o || o.length < 2) return
      this.searchCondition.startDate = o[0]
      this.searchCondition.endDate = o[1]
    },
    importStatus (val) {
      this.$emit('update:importStatus', val)
    },
    elType(v) {
      this.searchCondition.advertType = v ? v[0] : undefined
    },
    searchCondition: {
      deep: true,
      handler (nv, ov) {
        this.search()
      }
    }
  },
  methods: {
    contractHandle() {
      const trimNo = (this.contract || '').trim()
      this.searchCondition.contractNo = trimNo
    },
    async downloadTemplate () {
      await this.$exportGet(this.config.uploadTemplate)
    },
    beforeUpload (file) {
      if (file.size > 6 * 1024 * 1024) {
        this.$message.warning('文件大小超出限制')
        return false
      }
      if (!this.testInput()) return false
      this.fileObj.name = file.name
      this.fileObj.process = 0
      this.$emit('update:importStatus', 1)
    },
    uploadProgress (event, file, fileList) {
      this.fileObj.progress = event.percent
      this.$emit('progress', this.fileObj)
    },
    uploadSuccess (response, file, fileList) {
      this.$emit('update:importStatus', 2)
      this.fileObj.name = ''
      this.fileObj.process = 0
      if (response.code === 0) {
        this.importResultData = response.data
        this.search()
      } else {
        this.$message.error(response.message || response.msg)
        this.importResultData = {}
      }
    },
    search () {
      if (!this.importResultData || !this.importResultData.nbhdSearchList) return
      if (!this.testInput()) return
      this.$emit('search', { condition: this.searchCondition, result: this.importResultData })
    },
    testInput () {
      const { advertType, contractNo } = this.searchCondition
      if (!advertType) return this.messageTip('请选择广告类型', 2)
      if (!contractNo) return this.messageTip('请输入合同编码', 2)
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.ad_type {
  margin: 20px;
}
.put_order_form {
  margin: 20px;
  ::v-deep .el-form-item {
    margin-bottom: 20px;
    border: 1px solid #E9E9E9;
    border-radius: 4px;
    .el-input {
      input {
        border: none;
      }
    }
  }
  .custom.must {
    ::v-deep .el-form-item__label {
      &:before {
        left: 14px;
      }
    }
  }
  ::v-deep .el-form-item__label {
    line-height: 20px;
    padding-top: 0;
    padding-bottom: 0;
    margin: 10px 0;
    border-right: 1px solid #E9E9E9;
  }
  .el-input__inner {
    border: none !important;
  }
  .download_btn {
    width: 100%;
    margin-top: 10px;
    color: #FF3973;
    border: 1px solid #FF3973;
    &:hover {
      color: #FF3973;
      border: 1px solid #FF3973;
    }
  }
  .import_btn {
    width: 100%;
    margin-top: 10px;
    margin-left: 0;
    background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%);
    border: none;
    &.is-disabled {
      background: #bbb;
    }
  }
  .upload_btn {
    ::v-deep .el-upload {
      display: block;
    }
  }
  .txt_sub {
    display: block;
    text-align: center;
    margin-top: 10px;
    color: #999;
    font-size: 12px;
    line-height: 17px;
  }
}
</style>
